import ApiService from "./ApiService";
import utilityService from "./utilityService";
const getAll = async () => {
  const url = "/GetAllGlobalValues";
  try {
    const result = await ApiService.get(url);

    if (result.data) return result.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const getOne = async (columnName) => {
  const url = `/GetSingleValue?ColumnName=${columnName}`;
  try {
    const result = await ApiService.get(url);
    if (result.data) return result.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const update = async (data) => {
  // debugger
  const url = "/UpdateGlobalValues?" + utilityService.queryString(data);
  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to update global values",
    };
  }
};

// const add = async (data) => {
//   const _params = queryString(data);
//   const url = "/AddDecoMethod?" + _params;

//   try {
//     const result = await ApiService.post(url, data, {
//       "Content-Type": "application/json",
//     });
//     if (result.status === 200)
//       return {
//         success: true,
//         message: result.data,
//       };
//   } catch (err) {
//     console.log("ApiError", err.message);
//     return {
//       success: false,
//       message: "Failed to add new deco method",
//     };
//   }
// };

// const remove = async (id) => {
//   const url = "/DeleteDecoMethod?Id=" + id;

//   try {
//     const result = await ApiService.post(url);
//     if (result.status === 200)
//       return {
//         success: true,
//         message: result.data,
//       };
//   } catch (err) {
//     console.log("ApiError", err.message);
//     return {
//       success: false,
//       message: "Failed to add new deco method",
//     };
//   }
// };

export default {
  getAll,
  getOne,
  update,
};
